module.exports = __webpack_public_path__ + "static/media/get-into-action.83ec47d2.jpg";